<!--
 * @Author: Lemon C
 * @Date: 2024-05-15 15:07:01
 * @LastEditTime: 2025-01-07 17:01:24
-->
<template>
    <div class="sup-bady">
        <SearchBarComp class="search-bar-comp" :search_keywords="search_text" :search_bar_callback="search_bar_clickSearch"></SearchBarComp>
        <SearchComp class="search-comp" :search_keywords="search_text" :tree_sel_type="search_tree_sel_type"> </SearchComp>
    </div>
</template>

// MOD-- JavaScript
<script setup>
import { ref, onBeforeMount, getCurrentInstance } from 'vue';
import SearchBarComp from '../../components/Search/SearchBarComp.vue';
import SearchComp from '../../components/Search/SearchComp.vue';

const { proxy } = getCurrentInstance();

const search_text = ref('');
const search_tree_sel_type = ref(100);

onBeforeMount(() => {
    let queryDate = proxy.$route.query;
    if (queryDate && queryDate.keywords && queryDate.keywords.length > 0) {
        search_text.value = queryDate.keywords;
        if (queryDate.fromType) {
            search_tree_sel_type.value = Number(queryDate.fromType);
        }
        console.log('搜索数据: ' + queryDate.keywords);
    }
});

// MARK CallBack  搜索
const search_bar_clickSearch = (searchInput) => {
    search_text.value = searchInput;
};
</script>

// MOD-- CSS
<style lang="less" scoped>
.sup-bady {
    height: 100%;
    flex-direction: column;
    overflow: hidden;
    align-items: center;
    background-color: var(--color-main-dark-bg);

    .search-bar-comp {
        margin-top: 30px;
        flex-shrink: 0;
    }

    .search-comp {
        margin-top: 40px;
        width: 100%;
        flex: 1;
    }
}
</style>
